import {List, Map} from 'immutable'
import PropTypes from 'prop-types'
import {useState, useMemo} from 'react'
import {connect} from 'react-redux'
import {deleteResource, readEndpoint} from 'redux-json-api'

import {allOwnersActive} from '../../../../../lib/clientsEverplanStatus'
import {removedClientName, removedClientVerb} from '../../../../../lib/removeClientsTools'

import RemoveClient from './RemoveClient'
import {cleanResponse} from '../../../../../dashboard/src/components/corp_max/redux/apiHelper'
import {usesFuneralHomeBranding} from '../../../lib/firmTools'
import routerUtils from '../../../../../lib/routerUtils'
import {currentUserConfig} from '../../../../../lib/userTools'
import {findResourceById} from '../../../../../lib/plan_data/userData'
import {useNotificationContext} from '../../../../../shared_components/notifications/NotificationContext'
import {useEverplanData} from '../../../../../lib/hooks'

const RemoveClientController = props => {
  const everplanId = props.everplan.get('id')

  const [processing, setProcessing] = useState(false)
  const {alwaysNotify} = useNotificationContext()
  const {refetchItemResponses} = useEverplanData(everplanId)

  const activeOwners = useMemo(() => allOwnersActive(props.clientSeats), [props.clientSeats])

  const constructPayload = seatId => {
    if (activeOwners) {
      const id = props.userConfig.get('quarterback') ?
        props.quarterbackOwnership.get('id') :
        props.firmOwnership.get('id')

      return {type: 'client-households', id}
    } else {
      return {type: 'client-seats', id: seatId}
    }
  }

  const removeClientFromPro = clientSeat => {
    setProcessing(true)

    const payload = constructPayload(clientSeat.get('id'))
    const {clientSeats} = props

    const isHousehold = props.everplan.get('is-household')

    props.deleteResource(payload).then(() => {
      const firmId = props.userConfig.get('firm-id')

      if (firmId)
        props.readEndpoint(`client-stats/${firmId}`)

      if (!activeOwners && isHousehold)
        refetchItemResponses({everplanId: parseInt(everplanId, 10)})

      alwaysNotify.longSuccess(`${removedClientName({clientSeat, clientSeats})} ${removedClientVerb(clientSeats)} been removed.`)

      if (props.userConfig.get('quarterback'))
        routerUtils.push('pro/quarterback-admin/clients')
      else
        routerUtils.push('pro/clients')
    })
  }

  return (
    <RemoveClient
      {...props}
      processing={processing}
      removeClientFromPro={removeClientFromPro}
    />
  )
}

RemoveClientController.propTypes = {
  everplan: PropTypes.instanceOf(Map),
  clientSeat: PropTypes.instanceOf(Map),
  clientSeats: PropTypes.instanceOf(List),
  deleteResource: PropTypes.func,
  firmOwnership: PropTypes.instanceOf(Map),
  isFuneralHome: PropTypes.bool,
  userConfig: PropTypes.instanceOf(Map),
  owners: PropTypes.instanceOf(List),
  quarterbackOwnership: PropTypes.instanceOf(Map),
  readEndpoint: PropTypes.func
}

const mapStateToProps = ({api}) => {
  const userConfig = currentUserConfig(api)

  return {
    userConfig,
    isFuneralHome: usesFuneralHomeBranding({
      isConcierge: userConfig.get('quarterback'),
      firm: findResourceById({
        id: userConfig.get('firm-id'),
        resourceList: cleanResponse(api.firms)
      })
    })
  }
}

export default connect(mapStateToProps, {deleteResource, readEndpoint})(RemoveClientController)
